import { useState, useEffect, useRef } from "react";
import React from "react";
import axios from "axios";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import Breadcrumbs from "../components/Common/Breadcrumb";
import DeleteIcon from '@mui/icons-material/Delete'
import { confirmAlert } from 'react-confirm-alert' // Import
import 'react-confirm-alert/src/react-confirm-alert.css' // Import css
import md5 from "md5";
import Moment from 'moment'
import InputMask from 'react-input-mask';
import Headroom from "react-headroom";
import DialogTitle from '@mui/material/DialogTitle';
import Select from 'react-select';
import {
  Box,
  Button,
  Container,
  Stack,
  SvgIcon,
  Typography,
  Grid,
  Snackbar,
  TextField,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { styled } from "@mui/material/styles";
import Avatar from "@mui/material/Avatar";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import { useAlert } from "react-alert";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
// import { shallowEqual, useSelector, useDispatch } from 'react-redux'
import { TabPanel, TabContext, TabList } from "@mui/lab";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Paper from '@mui/material/Paper'

import { useLocation, Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import Multiselect from "multiselect-react-dropdown";
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined'
import Modal from '@mui/material/Modal';
import AddCircleOutlineRoundedIcon from '@mui/icons-material/AddCircleOutlineRounded';
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { FileUploader } from "react-drag-drop-files";
import TextareaAutosize from '@mui/material/TextareaAutosize';




const ProceduresRegistration = props => {
  const fields = [
    "id",
    "code",
    "description",
    "default_charges",
    "default_modifiers",
    "modifiers1",
    "modifiers2",
    "modifiers3",
    "modifiers4",
    "unit",
    "long_description",
    "pos",
    "isexpiered",
    "editable",
    "practiceId",
    "placeOfService"
  ];
  const defValues = {
    id: 0,
    code: "",
    description: "",
    default_charges: 0,
    default_modifiers: "",
    modifiers1: "",
    modifiers2: "",
    modifiers3: "",
    modifiers4: "",
    long_description: "",
    pos: "",
    isexpiered: true,
    editable: true,
    practiceId: 0,
    unit: '',
    placeOfService:""
  };
  const [date, setDate] = React.useState(Moment().format('YYYY-MM-DD'))

  const alert = useAlert();
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();


  const location = useLocation();
  const Proceduresid = location.state.Proceduresid;


  // API Authanticatiion
  const token = localStorage.getItem('Token')
  const auth = `Bearer ${token}`
  const headers = {
    Authorization: auth
  }
  const UserType = localStorage.getItem("User_Type")
  console.log('UserType', UserType)
  const validationSchema = Yup.object({
    // fullName: Yup.string().required("Full Name is required"),
    code: Yup.string().required("Code is required"),


    // defaultPracticeId: Yup.array().required("Practice Name is required")
  });
  const {
    register,
    control,
    handleSubmit,
    getValues,
    setValue,
    formState: { errors }
  } = useForm({
    mode: "onBlur",
    reValidateMode: "onChange",
    context: undefined,
    criteriaMode: "firstError",
    shouldFocusError: true,
    shouldUnregister: false,
    shouldUseNativeValidation: false,
    delayError: undefined,
    resolver: yupResolver(validationSchema),
    defaultValues: defValues
  });

  const onSubmit = data => {

    let postData = data;
    setSubmitting(true);
    postData.practiceId = localStorage.getItem('default_paractice')
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/Procedures/AddProcedures`,
        postData,
        { headers }
      )
      .then(response => {
        if (response.id > 0) {
          setSubmitting(false);

          alert.success("Record saved successfully.", {
            type: "success",
            onClose: () => {
              navigate("/Procedures");
            }
          });
        }
      })
      .catch(error => {
        setSubmitting(false);
        alert.error(`Error ${error.message}`, {
          type: "error"
        });
      });
  };




  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/Procedures/ProceduresById?id=${Proceduresid}`, {
        headers
      })
      .then(response => {
        // setEmergencycontantid(response.id)
        fields.forEach(field => {
          setValue(field, response[field]);
          var dateYMD = Moment(response.dateTime).format('YYYY-MM-DD')
          setDate(dateYMD)

        });

      })
      .catch(error => { });
  }, []);

  function handleCancel() {
    navigate("/Procedures");
  }

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    // width: 500,
    height: 400,
    bgcolor: 'white',
    border: '2px solid #3C7F6B',
    boxShadow: 24,
    overflow: 'hidden',
    // p: 4,
    borderRadius: '8px',
    overflow: 'auto',
    /* WebKit (Chrome, Safari) */
    '&::-webkit-scrollbar': {
      width: 8, /* Width of vertical scrollbar */
      height: 10,
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#3C7F6B',
      borderRadius: 10,
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: 'transparent',
    },
    /* Adjust the width for the horizontal scrollbar */
    '&::-webkit-scrollbar-thumb:horizontal': {
      width: 4, /* Width of horizontal scrollbar */
    },
    /* For Firefox */
    '&*': {
      scrollbarWidth: 'thin',
    },
  }
 const placeOfServiceOptions = [
  { value: '01', label: '01 - Pharmacy' },
  { value: '02', label: '02 - Telehealth Provided Other than in Patient’s Home' },
  { value: '03', label: '03 - School' },
  { value: '04', label: '04 - Homeless Shelter' },
  { value: '05', label: '05 - Indian Health Service Free-standing Facility' },
  { value: '06', label: '06 - Indian Health Service Provider-based Facility' },
  { value: '07', label: '07 - Tribal 638 Free-standing Facility' },
  { value: '08', label: '08 - Tribal 638 Provider-based Facility' },
  { value: '09', label: '09 - Prison/ Correctional Facility' },
  { value: '10', label: '10 - Telehealth Provided in Patient’s Home' },
  { value: '11', label: '11 - Office' },
  { value: '12', label: '12 - Home' },
  { value: '13', label: '13 - Assisted Living Facility' },
  { value: '14', label: '14 - Group Home' },
  { value: '15', label: '15 - Mobile Unit' },
  { value: '16', label: '16 - Temporary Lodging' },
  { value: '17', label: '17 - Walk-in Retail Health Clinic' },
  { value: '18', label: '18 - Place of Employment-Worksite' },
  { value: '19', label: '19 - Off Campus-Outpatient Hospital' },
  { value: '20', label: '20 - Urgent Care Facility' },
  { value: '21', label: '21 - Inpatient Hospital' },
  { value: '22', label: '22 - On Campus-Outpatient Hospital' },
  { value: '23', label: '23 - Emergency Room – Hospital' },
  { value: '24', label: '24 - Ambulatory Surgical Center' },
  { value: '25', label: '25 - Birthing Center' },
  { value: '26', label: '26 - Military Treatment Facility' },
  { value: '27', label: '27 - Outreach Site/ Street' },
  { value: '28-30', label: '28-30 - Unassigned' },
  { value: '31', label: '31 - Skilled Nursing Facility' },
  { value: '32', label: '32 - Nursing Facility' },
  { value: '33', label: '33 - Custodial Care Facility' },
  { value: '34', label: '34 - Hospice' },
  { value: '35-40', label: '35-40 - Unassigned' },
  { value: '41', label: '41 - Ambulance Land' },
  { value: '42', label: '42 - Ambulance – Air or Water' },
  { value: '43-48', label: '43-48 - Unassigned' },
  { value: '49', label: '49 - PIndependent Clinic' },
  { value: '50', label: '50 - Federally Qualified Health Center' },
  { value: '51', label: '51 - Inpatient Psychiatric Facility' },
  { value: '52', label: '52 - Psychiatric Facility-Partial Hospitalization' },
  { value: '53', label: '53 - Community Mental Health Center' },
  { value: '54', label: '54 - Intermediate Care Facility/ Individuals with Intellectual Disabilities' },
  { value: '55', label: '55 - Residential Substance Abuse Treatment Facility' },
  { value: '56', label: '56 - Psychiatric Residential Treatment Center' },
  { value: '57', label: '57 - Non-residential Substance Abuse Treatment Facility' },
  { value: '58', label: '58 - Non-residential Opioid Treatment Facility' },
  { value: '59', label: '59 - Unassigned' },
  { value: '60', label: '60 - Mass Immunization Center' },
  { value: '61', label: '61 - Comprehensive Inpatient Rehabilitation Facility' },
  { value: '62', label: '62 - Comprehensive Outpatient Rehabilitation Facility' },
  { value: '63-64', label: '63-64 - Unassigned' },
  { value: '65', label: '65 - End-Stage Renal Disease Treatment Facility' },
  { value: '66', label: '66 - Programs of All-Inclusive Care for the Elderly (PACE) Center' },
  { value: '67-70', label: '67-70 - Unassigned' },
  { value: '71', label: '71 - Public Health Clinic' },
  { value: '72', label: '72 - Rural Health Clinic' },
  { value: '73-80', label: '73-80 - Unassigned' },
  { value: '81', label: '81 - Independent Laboratory' },
  { value: '82-98', label: '82-98 - Unassigned' },
  { value: '99', label: '99 - Other Place of Service' }
];
  
  return (
    <React.Fragment>
      <Grid container className="page-content" >
        <Box sx={style}>

          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} xl={12}   >

              <Headroom>
                <Grid
                  container
                  style={{ backgroundColor: '#356F60', position: 'sticky' }}
                >
                  <Grid item xs={12} sm={12} xl={12}>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        height: '2.5rem'
                      }}
                    >
                      <DialogTitle
                        style={{
                          flex: 1,
                          textAlign: 'center',
                        }}
                      >
                        <h1
                          style={{
                            fontWeight: 'bold',
                            textAlign: 'center',
                            color: '#fff',
                            // textDecoration: 'underline',
                            fontSize: '1.5rem'

                          }}
                        >
                          Procedures Registration

                        </h1>
                      </DialogTitle>
                      <CancelOutlinedIcon
                        onClick={handleCancel}
                        fontSize="large"
                        color="red"
                        style={{
                          color: 'red',
                          paddingRight: '5px',
                          cursor: 'pointer',
                          float: 'right'
                          // marginLeft: 'auto',
                          // marginRight: '1.5rem'
                        }}
                      ></CancelOutlinedIcon>

                    </div>
                  </Grid>
                </Grid>
              </Headroom>
            </Grid>
            <Grid item xs={0.5} sm={0.5} xl={0.5}></Grid>

            <Grid item xs={11} sm={11} xl={11}>
              <Typography style={{ fontSize: '14px' }}>
                CPT Code
              </Typography>
            </Grid>
            <Grid item xs={0.5} sm={0.5} xl={0.5}></Grid>

            <Grid item xs={0.5} sm={0.5} xl={0.5}></Grid>

            <Grid item xs={11} sm={11} xl={11}>
              <Controller
                name="code"
                {...register("code")}
                control={control}
                render={({ field }) =>
                  <TextField
                    size="small"
                    placeholder="Please enter Code"
                    {...field}
                    fullWidth
                    error={errors.code}
                  />}
              />
              <p style={{ color: 'red', fontSize: '14px' }}>{errors.code?.message}</p>
            </Grid>
            <Grid item xs={0.5} sm={0.5} xl={0.5}></Grid>
            <Grid item xs={0.5} sm={0.5} xl={0.5}></Grid>

            <Grid item xs={11} sm={11} xl={11}>
              <Typography style={{ fontSize: '14px' }}>
                Charges
              </Typography>
            </Grid>
            <Grid item xs={0.5} sm={0.5} xl={0.5}></Grid>

            <Grid item xs={0.5} sm={0.5} xl={0.5}></Grid>

            <Grid item xs={11} sm={11} xl={11}>
              <Controller
                name="default_charges"
                control={control}
                render={({ field }) => (
                  <TextField
                    type="text"
                    required
                    name="price"
                    size="small"
                    placeholder="Please enter Charges"
                    fullWidth
                    value={field.value} // Ensure value is controlled by react-hook-form
                    onChange={(e) => {
                      const inputValue = e.target.value.trim();
                      if (inputValue === '' || /^\d*\.?\d{0,2}$/.test(inputValue)) {
                        field.onChange(inputValue);
                      }
                    }}
                    inputProps={{
                      inputMode: 'numeric',
                      pattern: '^\\d*\\.?\\d{0,2}$',
                      inputMode: 'numeric',
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={0.5} sm={0.5} xl={0.5}></Grid>
            <Grid item xs={0.5} sm={0.5} xl={0.5}></Grid>

            <Grid item xs={11} sm={11} xl={11}>
              <Typography style={{ fontSize: '14px' }}>
                Place of Service
              </Typography>
            </Grid>
            <Grid item xs={0.5} sm={0.5} xl={0.5}></Grid>
            <Grid item xs={0.5} sm={0.5} xl={0.5}></Grid>

            <Grid item xs={11} sm={11} xl={11}>
            <Controller
  name="placeOfService"
  control={control}
  render={({ field }) => (
    <Select
      {...field}
      options={placeOfServiceOptions}
      placeholder="Select Place Of Service"
      onChange={(selectedOption) => field.onChange(selectedOption?.value)}
      value={placeOfServiceOptions.find(option => option.value === field.value)}
      isClearable
    />
  )}
/>
            </Grid>
            <Grid item xs={0.5} sm={0.5} xl={0.5}></Grid>
            <Grid item xs={0.5} sm={0.5} xl={0.5}></Grid>
            <Grid item xs={11} sm={11} xl={11}>
              <Typography style={{ fontSize: '14px' }}>
                Modifier 1
              </Typography>
            </Grid>
            <Grid item xs={0.5} sm={0.5} xl={0.5}></Grid>
            <Grid item xs={0.5} sm={0.5} xl={0.5}></Grid>
            <Grid item xs={11} sm={11} xl={11}>
              <Controller
                name="modifiers1"
                {...register("modifiers1")}
                control={control}
                render={({ field }) =>
                  <TextField
                    size="small"
                    placeholder="Please enter Modifier 1"
                    {...field}
                    fullWidth
                  />}
              />
            </Grid>
            <Grid item xs={0.5} sm={0.5} xl={0.5}></Grid>
            <Grid item xs={0.5} sm={0.5} xl={0.5}></Grid>
            <Grid item xs={11} sm={11} xl={11}>
              <Typography style={{ fontSize: '14px' }}>
                Modifier 2
              </Typography>
            </Grid>
            <Grid item xs={0.5} sm={0.5} xl={0.5}></Grid>
            <Grid item xs={0.5} sm={0.5} xl={0.5}></Grid>

            <Grid item xs={11} sm={11} xl={11}>
              <Controller
                name="modifiers2"
                {...register("modifiers2")}
                control={control}
                render={({ field }) =>
                  <TextField
                    size="small"
                    placeholder="Please enter Modifier 2"
                    {...field}
                    fullWidth
                  />}
              />
            </Grid>
            <Grid item xs={0.5} sm={0.5} xl={0.5}></Grid>
            <Grid item xs={0.5} sm={0.5} xl={0.5}></Grid>
            <Grid item xs={11} sm={11} xl={11}>
              <Typography style={{ fontSize: '14px' }}>
                Modifier 3
              </Typography>
            </Grid>
            <Grid item xs={0.5} sm={0.5} xl={0.5}></Grid>
            <Grid item xs={0.5} sm={0.5} xl={0.5}></Grid>
            <Grid item xs={11} sm={11} xl={11}>
              <Controller
                name="modifiers3"
                {...register("modifiers3")}
                control={control}
                render={({ field }) =>
                  <TextField
                    size="small"
                    placeholder="Please enter Modifier 3"
                    {...field}
                    fullWidth
                  />}
              />
            </Grid>
            <Grid item xs={0.5} sm={0.5} xl={0.5}></Grid>
            <Grid item xs={0.5} sm={0.5} xl={0.5}></Grid>
            <Grid item xs={11} sm={11} xl={11}>
              <Typography style={{ fontSize: '14px' }}>
                Modifier 4
              </Typography>
            </Grid>
            <Grid item xs={0.5} sm={0.5} xl={0.5}></Grid>
            <Grid item xs={0.5} sm={0.5} xl={0.5}></Grid>
            <Grid item xs={11} sm={11} xl={11}>
              <Controller
                name="modifiers4"
                {...register("modifiers4")}
                control={control}
                render={({ field }) =>
                  <TextField
                    size="small"
                    placeholder="Please enter Modifier 4"
                    {...field}
                    fullWidth
                  />}
              />
            </Grid>
            <Grid item xs={0.5} sm={0.5} xl={0.5}></Grid>
            <Grid item xs={0.5} sm={0.5} xl={0.5}></Grid>
            <Grid item xs={11} sm={11} xl={11}>
              <Typography style={{ fontSize: '14px' }}>
                Units
              </Typography>
            </Grid>
            <Grid item xs={0.5} sm={0.5} xl={0.5}></Grid>
            <Grid item xs={0.5} sm={0.5} xl={0.5}></Grid>
            <Grid item xs={11} sm={11} xl={11}>
              <Controller
                name="unit"
                {...register("unit")}
                control={control}
                render={({ field }) =>
                  <TextField
                    size="small"
                    onChange={(e) => {
                      setValue('unit', e.target.value)
                    }}
                    placeholder="Please Enter Units"
                    {...field}
                    fullWidth
                  />}
              />
            </Grid>
            <Grid item xs={0.5} sm={0.5} xl={0.5}></Grid>
            <Grid item xs={0.5} sm={0.5} xl={0.5}></Grid>
            <Grid item xs={11} sm={11} xl={11}>
              <Typography style={{ fontSize: '14px' }}>
                Description
              </Typography>
            </Grid>
            <Grid item xs={0.5} sm={0.5} xl={0.5}></Grid>
            <Grid item xs={0.5} sm={0.5} xl={0.5}></Grid>
            <Grid item xs={11} sm={11} xl={11}>
              <Controller
                name='description'
                {...register('description')}
                control={control}
                render={({ field }) => (
                  <TextareaAutosize
                    aria-label='minimum height'
                    minRows={1}
                    placeholder='Enter Details  Description'
                    style={{
                      width: '100%',
                      borderRadius: '8px',
                      border: '2px solid #black',
                      height: '100px', // set a fixed height here
                      //   overflow: 'scroll'
                    }}
                    {...field}
                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid item xs={0.5} sm={0.5} xl={0.5}></Grid>
            <Grid item xs={0.5} sm={0.5} xl={0.5}></Grid>
            <Grid item xs={5.5} sm={5.5} xl={5.5} style={{ marginTop: '10px', marginBottom: '10px' }}>
              <Button
                className="Button"
                onClick={handleSubmit(onSubmit)}
                disabled={submitting}
                fullWidth
                style={{ borderRadius: '10px', color: 'white', height: '40px', borderColor: "#EA7772", fontSize: '14px', fontWeight: 'bold' }}
                type="submit"
              >
                Save
              </Button>
            </Grid>
            <Grid item xs={5.5} sm={5.5} xl={5.5} style={{ marginTop: '10px', marginBottom: '10px' }}>
              <Button
                className="Button"
                onClick={handleCancel}
                disabled={submitting}
                fullWidth
                style={{ borderRadius: '10px', color: 'white', height: '40px', borderColor: "#EA7772", fontSize: '14px', fontWeight: 'bold' }}
              >
                Cancel
              </Button>
            </Grid>
            <Grid item xs={0.5} sm={0.5} xl={0.5}></Grid>
          </Grid>
        </Box>
      </Grid>
    </React.Fragment>
  );
};
export default ProceduresRegistration;
